/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';

/** Full-page loading state shown by the v3 public auth pages while the organization data is still loading. */
@Component({
  selector: 'ptl-v3-auth-loading',
  templateUrl: './v3-auth-loading.component.html',
  styleUrls: ['./v3-auth-loading.component.scss'],
})
export class V3AuthLoadingComponent {}
